import React from 'react'
import { Text, Tooltip, csx } from '@vtex/admin-ui'
import { FormattedMessage } from 'react-intl'

export const PriceTooltip = () => (
  <Tooltip text={(<FormattedMessage id="price-tooltip" />) as any}>
    <div
      className={csx({
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        background: '#DDD', // [TODO]<theme>: $gray20
        borderRadius: '$pill',
        width: '1rem',
        height: '1rem',
        marginX: '$space-1',
      })}
    >
      <Text className={csx({ fontSize: '0.625rem' })}>{'?'}</Text>
    </div>
  </Tooltip>
)
